'use client'

import type { Editor } from '@tiptap/react'

import { EditorColorPicker } from './editor-color-picker.atom'
import { emojiButton, highlightButton } from './editor-toolbar.config'
import { EditorToolbarButton } from './editor-toolbar-button.atom'
import { EditorToolbarDivider } from './editor-toolbar-divider.atom'

export interface EditorToolbarColorToolsProps {
  editor: Editor
  isDisabled?: boolean
}

/**
 * Color-related toolbar section (emoji, color picker, highlight)
 */
export const EditorToolbarColorTools = ({
  editor,
  isDisabled = false,
}: EditorToolbarColorToolsProps) => {
  const handleColorSelect = (color: string | null) => {
    if (!color) {
      editor.chain().focus().unsetColor().run()
      return
    }
    editor.chain().focus().setColor(color).run()
  }

  return (
    <>
      <EditorToolbarButton
        label={emojiButton.label}
        onClick={() => emojiButton.action(editor)}
        disabled={isDisabled}
      >
        <emojiButton.icon className="size-4" />
      </EditorToolbarButton>

      <EditorToolbarDivider />

      <EditorColorPicker
        currentColor={editor.getAttributes('textStyle').color}
        onColorSelect={handleColorSelect}
        disabled={isDisabled}
      />
      <EditorToolbarButton
        label={highlightButton.label}
        isActive={highlightButton.isActive?.(editor)}
        onClick={() => highlightButton.action(editor)}
        disabled={isDisabled}
      >
        <highlightButton.icon className="size-4" />
      </EditorToolbarButton>
    </>
  )
}

EditorToolbarColorTools.displayName = 'EditorToolbarColorTools'
